import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/bootstrap.custom.css';
import './assets/styles/index.css';
import App from './App';

import { Provider } from 'react-redux';
import store from './store';

import PrivateRoute from './components/PrivateRoute';

import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';

// Screens
import SquadDataScreen from './screens/SquadDataScreen';
import ShotDataScreen from './screens/ShotDataScreen';
import ShotAnalysisScreen from './screens/ShotAnalysisScreen';
import InformationScreen from './screens/InformationScreen';
import SeasonAnalysisScreen from './screens/SeasonAnalysisScreen';
import PlayerAnalysisScreen from './screens/PlayerAnalysisScreen';
import WhatIsShotArcScreen from './screens/WhatIsShotArcScreen';

import RegisterScreen from './screens/RegisterScreen';
import LoginScreen from './screens/LoginScreen';
import UpdatePasswordScreen from './screens/UpdatePasswordScreen';
import ResetForgottenPasswordScreen from './screens/ResetForgotttenPasswordScreen';
import VerifyEmailScreen from './screens/VerifyEmailScreen';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      {/* Public Routes */}
      <Route path="/LoginScreen" element={<LoginScreen />} />
      <Route path="/RegisterScreen" element={<RegisterScreen />} />
      <Route path="/WhatIsShotArc" element={<WhatIsShotArcScreen />} />
      <Route path="/UpdatePassword" element={<UpdatePasswordScreen />} />
      <Route path="/ForgotPassword" element={<ResetForgottenPasswordScreen />} />
      <Route path="/TermsOfUse" element={<InformationScreen />} />
      <Route path="/ResetForgottenPassword/:email/:token" element={<ResetForgottenPasswordScreen />} />
      <Route path="/VerifyEmail" element={<VerifyEmailScreen />} />

      {/* Protected Routes */}
      <Route element={<PrivateRoute />}>
        <Route index element={<SquadDataScreen />} />
        <Route path="/SquadDataScreen" element={<SquadDataScreen />} />
        <Route path="/ShotDataScreen" element={<ShotDataScreen />} />
        <Route path="/ShotAnalysisScreen" element={<ShotAnalysisScreen />} />
        <Route path="/InformationScreen" element={<InformationScreen />} />
        <Route path="/SeasonAnalysisScreen" element={<SeasonAnalysisScreen />} />
        <Route path="/PlayerAnalysisScreen" element={<PlayerAnalysisScreen />} />
      </Route>
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);
